import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditComponent } from './pages/edit/edit.component';
import { MasterComponent } from '../layout/pages/master/master.component';
import { AuthGuard } from '../auth/auth.guard';
import { EditChangesGuard } from './edit-changes.guard';

const routes: Routes = [
  {
    path: 'edit',
    component: MasterComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'new',
        pathMatch: 'full',
        component: EditComponent,
        canDeactivate: [EditChangesGuard]
      },
      {
        component: EditComponent,
        path: '**',
        canDeactivate: [EditChangesGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditRoutingModule { }
